export interface CabinAdvancedConfig {
  activarCabina: boolean;
  mensajesVoz: boolean;
  solicitudes: boolean;
  concursos: boolean;
}

export interface CabinModerationConfig {
  palabrasBloqueadas: string[];
  bloquearSpam: boolean;
  bloquearLinks: boolean;
  bloquearFlood: boolean;
  maxFloodMensajes: number;
  bloqueoAutomatico: boolean;
  advertenciasAntesBloqueo: number;
  tiempoCastigoMinutos: number;
}

export interface CabinBannedUser {
  id: string;
  username: string;
  motivo: string;
  tipo: 'temporal' | 'permanente' | 'ip';
  fecha: string;
  duracion: string;
  baneadoPor: string;
  activo: boolean;
}

export interface CabinBannedIP {
  id: string;
  ip: string;
  motivo: string;
  fecha: string;
  baneadoPor: string;
  activo: boolean;
}

export interface CabinModHistoryEntry {
  id: string;
  timestamp: string;
  admin: string;
  accion: string;
  objetivo: string;
  tipoObjetivo: 'mensaje' | 'usuario' | 'ip' | 'palabra' | 'sistema';
  detalles: string;
}

export const defaultCabinConfig: CabinAdvancedConfig = {
  activarCabina: true,
  mensajesVoz: true,
  solicitudes: true,
  concursos: false,
};

export const defaultCabinModeration: CabinModerationConfig = {
  palabrasBloqueadas: [
    'spam', 'ofensivo', 'insulto', 'p***', 'm****a', 'c*****',
    'idiota', 'estúpido', 'imbécil', 'h*******a', 'tonto',
  ],
  bloquearSpam: true,
  bloquearLinks: true,
  bloquearFlood: true,
  maxFloodMensajes: 5,
  bloqueoAutomatico: true,
  advertenciasAntesBloqueo: 3,
  tiempoCastigoMinutos: 60,
};

export const cabinBannedUsers: CabinBannedUser[] = [
  {
    id: 'cbu-1',
    username: 'TrollMaster99',
    motivo: 'Insultos graves y acoso a oyentes durante Tardes de Pop.',
    tipo: 'permanente',
    fecha: '2026-04-12',
    duracion: 'Permanente',
    baneadoPor: 'Carlos Mendoza',
    activo: true,
  },
  {
    id: 'cbu-2',
    username: 'SpamBot_CR',
    motivo: 'Spam masivo con links de phishing en 3 programas distintos.',
    tipo: 'ip',
    fecha: '2026-03-28',
    duracion: 'Permanente',
    baneadoPor: 'Diego Ramírez',
    activo: true,
  },
  {
    id: 'cbu-3',
    username: 'ElToxico506',
    motivo: 'Lenguaje ofensivo y amenazas contra la locutora Natalia.',
    tipo: 'permanente',
    fecha: '2026-05-01',
    duracion: 'Permanente',
    baneadoPor: 'Carlos Mendoza',
    activo: true,
  },
  {
    id: 'cbu-4',
    username: 'DJ_Falso_7',
    motivo: 'Suplantación de identidad de un locutor de la radio.',
    tipo: 'temporal',
    fecha: '2026-05-18',
    duracion: '30 días',
    baneadoPor: 'María Solís',
    activo: true,
  },
  {
    id: 'cbu-5',
    username: 'MusicLover23',
    motivo: 'Misma canción solicitada 12 veces en 10 minutos.',
    tipo: 'temporal',
    fecha: '2026-05-25',
    duracion: '24 horas',
    baneadoPor: 'Diego Ramírez',
    activo: true,
  },
  {
    id: 'cbu-6',
    username: 'RadioFan506',
    motivo: 'Publicidad no autorizada de radio competidora.',
    tipo: 'temporal',
    fecha: '2026-06-02',
    duracion: '7 días',
    baneadoPor: 'Carlos Mendoza',
    activo: true,
  },
  {
    id: 'cbu-7',
    username: 'Xx_Hater_xX',
    motivo: 'Insultos racistas en especial de música afrocaribeña.',
    tipo: 'ip',
    fecha: '2026-01-20',
    duracion: 'Permanente',
    baneadoPor: 'Carlos Mendoza',
    activo: true,
  },
  {
    id: 'cbu-8',
    username: 'AnonCR2024',
    motivo: 'Comportamiento tóxico recurrente. Tercera advertencia.',
    tipo: 'temporal',
    fecha: '2026-03-10',
    duracion: '14 días',
    baneadoPor: 'María Solís',
    activo: false,
  },
];

export const cabinBannedIPs: CabinBannedIP[] = [
  {
    id: 'cbip-1',
    ip: '201.198.67.34',
    motivo: 'Spam masivo con links maliciosos.',
    fecha: '2026-03-28',
    baneadoPor: 'Diego Ramírez',
    activo: true,
  },
  {
    id: 'cbip-2',
    ip: '186.45.67.90',
    motivo: 'Insultos racistas y lenguaje de odio.',
    fecha: '2026-01-20',
    baneadoPor: 'Carlos Mendoza',
    activo: true,
  },
  {
    id: 'cbip-3',
    ip: '190.88.123.44',
    motivo: 'Ataque de bots generando mensajes falsos.',
    fecha: '2026-02-14',
    baneadoPor: 'Sistema',
    activo: true,
  },
  {
    id: 'cbip-4',
    ip: '181.33.99.77',
    motivo: 'Intentos repetidos de publicar links de apuestas.',
    fecha: '2026-05-30',
    baneadoPor: 'Carlos Mendoza',
    activo: true,
  },
  {
    id: 'cbip-5',
    ip: '200.122.44.18',
    motivo: 'Suplantación de identidad del equipo de la radio.',
    fecha: '2026-04-05',
    baneadoPor: 'María Solís',
    activo: false,
  },
];

export const cabinModHistory: CabinModHistoryEntry[] = [
  {
    id: 'cmh-1',
    timestamp: '2026-06-08 09:15',
    admin: 'Carlos Mendoza',
    accion: 'Bloqueo permanente',
    objetivo: 'ElToxico506',
    tipoObjetivo: 'usuario',
    detalles: 'Lenguaje ofensivo reiterado. Tercera infracción grave.',
  },
  {
    id: 'cmh-2',
    timestamp: '2026-06-08 08:42',
    admin: 'Sistema',
    accion: 'Ocultar mensaje',
    objetivo: 'mensaje #45892',
    tipoObjetivo: 'mensaje',
    detalles: 'Filtro automático: palabra grave detectada. Mensaje ocultado.',
  },
  {
    id: 'cmh-3',
    timestamp: '2026-06-07 22:10',
    admin: 'Diego Ramírez',
    accion: 'Silenciar usuario',
    objetivo: 'Carlos_Troll_88',
    tipoObjetivo: 'usuario',
    detalles: 'Silenciado por 48 horas. Comentarios fuera de lugar en entrevista.',
  },
  {
    id: 'cmh-4',
    timestamp: '2026-06-07 21:33',
    admin: 'Sistema',
    accion: 'Reemplazar mensaje',
    objetivo: 'mensaje #45780',
    tipoObjetivo: 'mensaje',
    detalles: 'Filtro automático: palabra media reemplazada con ***.',
  },
  {
    id: 'cmh-5',
    timestamp: '2026-06-07 19:30',
    admin: 'María Solís',
    accion: 'Silenciar usuario',
    objetivo: 'MaríaFanatica',
    tipoObjetivo: 'usuario',
    detalles: 'Silenciada por 12 horas. Flood en concurso.',
  },
  {
    id: 'cmh-6',
    timestamp: '2026-06-07 16:55',
    admin: 'Carlos Mendoza',
    accion: 'Agregar palabra',
    objetivo: 'muérete (grave)',
    tipoObjetivo: 'palabra',
    detalles: 'Palabra agregada al filtro. Acción: bloquear temporal.',
  },
  {
    id: 'cmh-7',
    timestamp: '2026-06-06 18:20',
    admin: 'Sistema',
    accion: 'Bloqueo automático',
    objetivo: 'Usuario spam temporal',
    tipoObjetivo: 'usuario',
    detalles: '3 advertencias excedidas. Bloqueo automático por 60 min.',
  },
  {
    id: 'cmh-8',
    timestamp: '2026-06-06 14:00',
    admin: 'Carlos Mendoza',
    accion: 'Silenciar usuario',
    objetivo: 'ElChismosoCR',
    tipoObjetivo: 'usuario',
    detalles: 'Silenciado por 6 horas. Difundir información falsa.',
  },
  {
    id: 'cmh-9',
    timestamp: '2026-06-05 23:45',
    admin: 'Sistema',
    accion: 'Bloqueo por links',
    objetivo: 'IP 181.33.99.77',
    tipoObjetivo: 'ip',
    detalles: 'Intento de publicar link de apuestas. IP bloqueada.',
  },
  {
    id: 'cmh-10',
    timestamp: '2026-06-05 10:45',
    admin: 'Diego Ramírez',
    accion: 'Silenciar usuario',
    objetivo: 'DjNovato99',
    tipoObjetivo: 'usuario',
    detalles: 'Silenciado por 24 horas. Autopromoción en programa ajeno.',
  },
  {
    id: 'cmh-11',
    timestamp: '2026-06-04 15:30',
    admin: 'María Solís',
    accion: 'Desbloquear usuario',
    objetivo: 'AnonCR2024',
    tipoObjetivo: 'usuario',
    detalles: 'Bloqueo temporal cumplido. Usuario rehabilitado.',
  },
  {
    id: 'cmh-12',
    timestamp: '2026-06-04 12:10',
    admin: 'Carlos Mendoza',
    accion: 'Banear IP',
    objetivo: '186.45.67.90',
    tipoObjetivo: 'ip',
    detalles: 'IP baneada permanentemente. Insultos racistas.',
  },
  {
    id: 'cmh-13',
    timestamp: '2026-06-03 09:00',
    admin: 'Sistema',
    accion: 'Ocultar mensaje',
    objetivo: 'mensaje #45210',
    tipoObjetivo: 'mensaje',
    detalles: 'Filtro por mayúsculas excesivas. Mensaje ocultado.',
  },
  {
    id: 'cmh-14',
    timestamp: '2026-06-02 20:45',
    admin: 'Diego Ramírez',
    accion: 'Eliminar palabra',
    objetivo: 'palabra obsoleta',
    tipoObjetivo: 'palabra',
    detalles: 'Palabra removida del filtro por falsos positivos.',
  },
  {
    id: 'cmh-15',
    timestamp: '2026-06-02 18:10',
    admin: 'Carlos Mendoza',
    accion: 'Bloqueo temporal',
    objetivo: 'RadioFan506',
    tipoObjetivo: 'usuario',
    detalles: 'Bloqueado por 7 días. Publicidad no autorizada.',
  },
];

export const cabinaTabs = [
  { id: 'config', label: 'Configuración', icon: 'ri-settings-3-line', description: 'Activar cabina, mensajes de voz, solicitudes y concursos' },
  { id: 'moderacion', label: 'Moderación', icon: 'ri-shield-check-line', description: 'Palabras prohibidas, spam, links, flood y bloqueos automáticos' },
  { id: 'baneos', label: 'Baneos', icon: 'ri-forbid-2-line', description: 'Usuarios baneados, IPs bloqueadas e historial de moderación' },
];